import { config } from '@/config';

const DJANGO_LOGIN_PATH = '/account/two_factor/login/';

/** A route's address in the browser, e.g. `/map` becomes `/nabat-os/map` under the base path. */
export function appPath(route: string): string {
  const base = config.app.basename.replace(/\/+$/, '');
  return `${base}${route}`;
}

/** Django's sign-in page, which returns to `next` (a full browser path) once signed in. */
export function djangoLoginUrl(next: string = appPath('/map')): string {
  return `${DJANGO_LOGIN_PATH}?next=${encodeURIComponent(next)}`;
}
